import dayjs from 'dayjs';
import Vue from 'vue';
import Server from '@/common/models/server.model';
import downloadUrl from '@/common/utils/downloadUrl';
import getters from './servers.getters';

const resourceStr = '/api/v2/compute/servers';
const socketUpdates = true;

export default {
  name: 'servers',
  resource: resourceStr,
  Model: Server,
  socketUpdates,
  pagingSupport: true,
  getters,
  state: {
    pendingItems: {},
    serverHistories: {},
    serverEvents: {}
  },
  mutations: {
    SET_ITEM_PENDING(state, { serverId, target, value }) {
      Vue.set(state.pendingItems, `${serverId}.${target}`, value);
    },
    SET_SERVER_HISTORIES(state, { serverId, data }) {
      Vue.set(state.serverHistories, serverId, data);
    },
    SET_SERVER_EVENTS(state, { serverId, data }) {
      Vue.set(state.serverEvents, serverId, [data]);
    }
  },
  actions: ({ Model, resource }) => ({
    FETCH_SERVER_NETWORKS({ commit }, { id }) {
      commit('SET_ITEM_PENDING', { serverId: id, target: 'networks', value: true });
      return this.$api.get(`${resource}/${id}/interfaces`)
        .then((res) => {
          commit('CLEAR_ERRORS');
          commit('SET_ITEM_PENDING', { serverId: id, target: 'networks', value: false });
          commit('CHANGE', { item: new Model({ id, network_data: res.data.data }) });
          return res;
        });
    },
    FETCH_SERVER_HISTORIES({ commit }, { id }) {
      return this.$api.get(`${resource}/${id}/events`)
        .then((res) => {
          commit('SET_SERVER_HISTORIES', { serverId: id, data: res.data.data });
          return res;
        });
    },
    FETCH_SERVER_EVENTS({ commit }, { id, requestId }) {
      return this.$api.get(`${resource}/${id}/events/${requestId}`)
        .then((res) => {
          commit('SET_SERVER_EVENTS', { serverId: id, data: res.data });
          return res;
        });
    },
    ABORT_MIGRATION(_store, { id }) {
      return this.$api.post(`${resource}/${id}/migration/abort`);
    },
    RETRY_MIGRATION(_store, { id, migrationUuid }) {
      return this.$api.post(`${resource}/${id}/migration/${migrationUuid}/retry`);
    },
    DOWNLOAD_CONSOLE(store, { id, name }) {
      return this.$api.get(`${resource}/${id}/log`, {})
        .then((res) => {
          const blob = new Blob([res.data], { type: 'text/plain' });
          const url = window.URL.createObjectURL(blob);
          downloadUrl(url, `${name}-${dayjs().format('DD_MM_YYYY_H:mm')}-console.log`);
          return res;
        });
    },
    GET_SERVER_STAT({ commit }, server) {
      return this.$api.get(`${resource}/${server.id}/stat`, {})
        .then((res) => {
          commit('CHANGE', { item: new Model({ id: server.id, statistics: res.data }) });

          return res;
        })
        .catch((error) => {
          commit('SET_ERRORS', error);
          commit('errors/ADD_ERROR', error, { root: true });
          throw error;
        });
    },
    GET_SERVER_CONSOLE({ commit }, { id }) {
      return this.$api.get(`${resource}/${id}/console`, {})
        .then(res => res)
        .catch((error) => {
          commit('SET_ERRORS', error);
          commit('errors/ADD_ERROR', error, { root: true });
          throw error;
        });
    },
    DETACH_VOLUME(store, { id, actionBody = {} }) {
      const { commit } = store;
      return this.$api.delete(`${resourceStr}/${id}`, actionBody)
        .then((res) => {
          commit('CLEAR_ERRORS');
          !socketUpdates && commit('REMOVE', id); // If resource has socket updates it must be removed by socket notification
          return res;
        })
        .catch((error) => {
          commit('SET_ERRORS', error);
          throw error;
        });
    },
    UPDATE_TAG(store, { id, tag }) {
      return this.$api.put(`${resourceStr}/${id}/tags/${tag}`);
    },
    DELETE_TAG(store, { id, tag }) {
      return this.$api.delete(`${resourceStr}/${id}/tags/${tag}`);
    },

  })
};
